type Location = "tool_intro" | "tool_result" | "tool_bottom" | "article_inline";

interface Props {
  location: Location;
  page?: string;
}

const AFFILIATE_URL = "http://buy.infinitepay.io/smart?rid=ismaquedeoliveira";

export function InfinitePayBanner({ location, page = "simulador_maquininha" }: Props) {
  const handleClick = () => {
    try {
      if (typeof window !== "undefined" && typeof window.gtag === "function") {
        window.gtag("event", "affiliate_click", {
          category: "infinitepay",
          page,
          location,
        });
      }
    } catch {
      /* no-op */
    }
  };

  return (
    <aside
      className="ip-banner my-8 overflow-hidden rounded-2xl border border-emerald-500/30 bg-gradient-to-br from-emerald-500/10 via-emerald-400/5 to-transparent p-5 sm:p-6 shadow-soft"
      aria-label="Oferta InfinitePay"
    >
      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-6">
        <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-emerald-500/15 text-2xl ip-pulse">
          💚
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-[10px] font-bold uppercase tracking-widest text-emerald-600 dark:text-emerald-400">
            Recomendado · InfinitePay
          </div>
          <div className="mt-1 font-display text-base sm:text-lg font-bold text-foreground leading-snug">
            Maquininha com a menor taxa do mercado e recebimento em 1 dia
          </div>
          <div className="mt-1 text-xs sm:text-sm text-muted-foreground">
            Sem aluguel, sem fidelidade. Débito 1,09% · Crédito a partir de 2,69%.
          </div>
        </div>
        <a
          href={AFFILIATE_URL}
          target="_blank"
          rel="nofollow sponsored noopener"
          onClick={handleClick}
          className="ip-cta w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-full bg-emerald-500 px-5 py-3 text-sm font-bold text-white shadow-soft hover:bg-emerald-600 transition"
        >
          QUERO MINHA MAQUININHA COM DESCONTO →
        </a>
      </div>

      <style>{`
        @keyframes ip-pulse-kf {
          0%,100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(16,185,129,.45); }
          50%     { transform: scale(1.06); box-shadow: 0 0 0 8px rgba(16,185,129,0); }
        }
        .ip-pulse { animation: ip-pulse-kf 2.4s ease-in-out infinite; }
        @keyframes ip-cta-shine {
          0%   { background-position: -200% 0; }
          100% { background-position: 200% 0; }
        }
        .ip-cta {
          background-image: linear-gradient(110deg, #10b981 0%, #34d399 45%, #10b981 90%);
          background-size: 200% 100%;
          animation: ip-cta-shine 3.5s linear infinite;
        }
        @media (prefers-reduced-motion: reduce) {
          .ip-pulse, .ip-cta { animation: none; }
        }
      `}</style>
    </aside>
  );
}
